module.exports = __webpack_public_path__ + "img/Speaker=Victor Kovalev.68414495.png";